module.exports = __webpack_public_path__ + "static/media/logo-name.61b3aca7801033abd06bdf460818737d.svg";